// Imports
import { takeLatest, put, call } from 'redux-saga/effects';

// Types
import {
  LIST_NOTIFICATION_CAMPAIGN_REQUEST,
  LIST_NOTIFICATION_CAMPAIGN_SUCCESS,
  LIST_NOTIFICATION_CAMPAIGN_FAILURE,
  READ_NOTIFICATION_CAMPAIGN_REQUEST,
  READ_NOTIFICATION_CAMPAIGN_SUCCESS,
  READ_NOTIFICATION_CAMPAIGN_FAILURE,
  CREATE_NOTIFICATION_CAMPAIGN_REQUEST,
  CREATE_NOTIFICATION_CAMPAIGN_SUCCESS,
  CREATE_NOTIFICATION_CAMPAIGN_FAILURE,
} from './types';

// Actions
import { getNotificationCampaigns, readNotificationCampaign, createNotificationCampaign } from './actions';

/**
 * Function that handles getting a single NotificationCampaign
 *
 * @param {Object} deconstructed object
 * @returns {void}
 */
function* workerGetNotificationCampaigns({ token, query, direction, order, limit, page }) {
  try {
    const response = yield call(getNotificationCampaigns, {
      token,
      query,
      direction,
      order,
      limit,
      page,
    });

    const { data, pagination } = response.data;

    yield put({
      type: LIST_NOTIFICATION_CAMPAIGN_SUCCESS,
      data,
      pagination,
    });
  } catch (error) {
    console.log(error);
    const message = error.response && error.response.data ? error.response.data : null;
    yield put({ type: LIST_NOTIFICATION_CAMPAIGN_FAILURE, ...{ error: message } });
  }
}

// Exports
export function* watcherGetNotificationCampaigns() {
  yield takeLatest(LIST_NOTIFICATION_CAMPAIGN_REQUEST, workerGetNotificationCampaigns);
}
/**
 * Function that handles getting a single NotificationCampaign
 *
 * @param {Object} deconstructed object
 * @returns {void}
 */
function* workerReadNotificationCampaign({ token, id }) {
  try {
    const response = yield call(readNotificationCampaign, {
      token,
      id,
    });

    const { data } = response.data;

    yield put({
      type: READ_NOTIFICATION_CAMPAIGN_SUCCESS,
      data,
    });
  } catch (error) {
    const message = error.response && error.response.data ? error.response.data : null;
    yield put({ type: READ_NOTIFICATION_CAMPAIGN_FAILURE, ...{ error: message } });
  }
}

// Exports
export function* watcherReadNotificationCampaign() {
  yield takeLatest(READ_NOTIFICATION_CAMPAIGN_REQUEST, workerReadNotificationCampaign);
}

/**
 * Function that handles creating a single NotificationCampaign
 *
 * @param {Object} deconstructed object
 * @returns {void}
 */
function* workerCreateNotificationCampaign({ token, payload }) {
  try {
    const response = yield call(createNotificationCampaign, {
      token,
      payload,
    });
    console.log(response);
    const { data } = response.data;

    yield put({
      type: CREATE_NOTIFICATION_CAMPAIGN_SUCCESS,
      data,
    });
  } catch (error) {
    console.log(error);
    const message = error.response && error.response.data ? error.response.data : null;
    yield put({ type: CREATE_NOTIFICATION_CAMPAIGN_FAILURE, ...{ error: message } });
  }
}

// Exports
export function* watcherCreateNotificationCampaign() {
  yield takeLatest(CREATE_NOTIFICATION_CAMPAIGN_REQUEST, workerCreateNotificationCampaign);
}
